import _ from 'underscore';

const getParticipants = (id, type, scheduledMeeting) => {
	let participants = {
    'teacher': scheduledMeeting.teachers || [],
    'cohort': scheduledMeeting.cohorts || []
  };
  let active = participants[type];

  if(participants.teacher.length === 0 && participants.cohort.length === 0) {
  	participants = null;
  }
  else if(active) {
    participants[type] = _.reject(active, participant => {
      return participant.id === id
    });
  };

  return participants;
};

export const getCellHeight = cell => Math.floor(1.6 * cell.duration);

export const getCell = ({column, subColumns, scheduledMeeting, startTime, endTime}) => {
	let subColumn = subColumns[0] || {};
	let cell = {
		id: scheduledMeeting.id,
		column: column,
		subColumn: subColumn,
		subColumns: subColumns,
		scheduled: scheduledMeeting !== null ? scheduledMeeting.scheduled : false,
		scheduledMeeting: scheduledMeeting,
		startTime: startTime,
		endTime: endTime,
		duration: scheduledMeeting ? scheduledMeeting.duration : null,
		participants: getParticipants(subColumn.value, subColumn.type, scheduledMeeting)
	};

	cell.height = getCellHeight(cell);
	return cell;
};


/** WEBPACK FOOTER **
 ** ./src/js/lib/schedule_table/cell.js
 **/